import { styled } from '@acko-tech/building-blocks.ui.common';

export const CarCardList = styled.div`
    display: grid;
    overflow-x: auto;
    grid-auto-flow: column;
    gap: 10px;

    ::-webkit-scrollbar {
        display: none;
    }
`;
